import React from "react";
import { Box, Divider, Grid2, Typography } from "@mui/material";
import { Default_Text_Color } from "../../../constants/constants";
import {
  CustomTableView,
  CustomTextField,
  CustomDatePicker,
  CustomDropdown
} from "../../../utils/globalImports";

import {
  AssignmentOutlined,
  AccountBalanceWalletOutlined,
  RequestPageOutlined,
  ReceiptLongOutlined,
  MonetizationOnOutlined,
  InfoOutlined,
  TrendingUpOutlined
} from "@mui/icons-material";
import CustomCommercialDataTable from "../../../components/dataTable/CustomCommercialDataTable";

interface ProposalFeeStageCommercialDatesProps { }


const sectionIconMap: Record<string, React.ComponentType<any>> = {
  "Instructions": AssignmentOutlined,
  "WIP": TrendingUpOutlined,
  "AFP": RequestPageOutlined,
  "Pre-billing": ReceiptLongOutlined,
  "Invoicing": AssignmentOutlined,
};

const boxInputStyles = {
  borderRadius: '8px !important',
  height: '40px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px !important',
    height: '100%',
  },
  '& .MuiOutlinedInput-root.Mui-disabled .MuiInputBase-input::placeholder': {
    opacity: '0.9 !important',
  },
};


const boxDropdownStyles = {
  height: '40px',
  '& .MuiSelect-select': {
    borderRadius: '8px !important',
    paddingTop: '7px !important',
    paddingBottom: '7px !important',
    height: '40px !important',
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '8px !important',
  },
  '& .MuiOutlinedInput-root': {
    height: '100%',
  },
};


const boxDatePickerStyles = {
  height: '40px',
  '& .MuiInputBase-root': {
    borderRadius: '8px !important',
    height: '100%',
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px !important',
    height: '100%',
  },
  '& .MuiInputBase-input': {
    paddingTop: '7px !important',
    paddingBottom: '7px !important',
  },
};

const sampleData2 = [
  { wipDateAccrued: '25/2/2025', wipAmount: '1200', wipNotes: 'ABC' },
  { wipDateAccrued: '25/2/2025', wipAmount: '5000', wipNotes: 'ABCCC' },
  { wipDateAccrued: '25/2/2025', wipAmount: '6000', wipNotes: 'ABSSDJC' },
];
const columnsConfig = {
  wipDateAccrued: 'WIP Date Accrued',
  wipAmount: 'WIP Amount',
  wipNotes: 'WIP Notes',
};

const sampleDataTable2 = [
  { wipReleaseDate: '25/2/2025', wipDuration: '1200', wipReleaseComments: 'ABC' },
  { wipReleaseDate: '25/2/2025', wipDuration: '5000', wipReleaseComments: 'ABCCC' },
  { wipReleaseDate: '25/2/2025', wipDuration: '6000', wipReleaseComments: 'ABSSDJC' },
];
const columnsConfig2 = {
  wipReleaseDate: 'WIP Release Accrued',
  wipDuration: 'WIP Duration',
  wipReleaseComments: 'WIP Release Comments',
};

const sampleDataTableAFP = [
  { afpref: 'A01', value: '1200', afpStatus: 'Working on it', dateSent: '25/2/2025', dateCertDue: '25/2/2025', dateInvoiced: '25/2/2025', dateCertReceived: '25/2/2025' },
  { afpref: 'A02', value: '5000', afpStatus: 'Sent', dateSent: '25/2/2025', dateCertDue: '25/2/2025', dateInvoiced: '25/2/2025', dateCertReceived: '25/2/2025' },
  { afpref: 'A03', value: '6000', afpStatus: 'Invoiced', dateSent: '25/2/2025', dateCertDue: '25/2/2025', dateInvoiced: '25/2/2025', dateCertReceived: '25/2/2025' },
];
const columnsConfigAFP = {
  afpref: 'AFP Ref',
  value: 'Value',
  afpStatus: 'AFP Status',
  dateSent: 'Date Sent',
  dateCertDue: 'Date Cert Due',
  dateInvoiced: 'Date Invoiced',
  dateCertReceived: 'Date Cert Received',
};

const sampleDataTableprebilling1 = [
  { preBillingAccruedDates: '25/2/2025', accureValue: '1200', AssociatedValue: '' },
  { preBillingAccruedDates: '25/2/2025', accureValue: '5000', AssociatedValue: '' },
  { preBillingAccruedDates: '25/2/2025', accureValue: '6000', AssociatedValue: '' },
];
const columnsConfigprebilling1 = {
  preBillingAccruedDates: 'Pre-billing Accrued Dates',
  accureValue: 'Accrue Value',
  AssociatedValue: 'Associated Invoice',
};

const sampleDataTableprebilling2 = [
  { prebillingreleasedates: 'A01', releasevalue: '1200', balance: 'Working on it', comments: '25/2/2025' },
  { prebillingreleasedates: 'A02', releasevalue: '5000', balance: 'Sent', comments: '25/2/2025' },
  { prebillingreleasedates: 'A03', releasevalue: '6000', balance: 'Invoiced', comments: '25/2/2025' },
];
const columnsConfigprebilling2 = {
  prebillingreleasedates: 'Pre-Billing Release Dates',
  releasevalue: 'Release Value',
  balance: 'Balance',
  comments: 'Comments',
};

const sampleDataTableInvoicing = [
  { Invoices: 'A01', value: '1200', DateSent: '25/2/2025', datepaymentdue: '25/2/2025', paymentReceived: 'N', daysOverdue: '12' },
  { Invoices: 'A02', value: '5000', DateSent: '25/2/2025', datepaymentdue: '25/2/2025', paymentReceived: 'N', daysOverdue: '3' },
  { Invoices: 'A03', value: '6000', DateSent: '25/2/2025', datepaymentdue: '25/2/2025', paymentReceived: 'Y', daysOverdue: '0' },
];
const columnsConfigInvoicing = {
  Invoices: 'Invoices',
  value: 'Value',
  DateSent: 'Date Sent',
  datepaymentdue: 'Date Payment is Due',
  paymentReceived: 'Payment Received Y/N',
  daysOverdue: 'Days Overdue',
};


// const fieldStyle = {
//   width: '100%',
//   height: '45px',
//   borderRadius: '8px',
//   border: '1px solid #f0f4ff',
//   backgroundColor: '#ffffff',
//   boxSizing: 'border-box' as const,
//   fontFamily: '"Poppins", sans-serif',
//   color: '#333333',
//   '& input': { padding: '12px 14px', color: '#333333', fontSize: '14px' },
//   '& .MuiOutlinedInput-root': { height: '45px', borderRadius: '8px' },
//   '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d0d0d0' },
//   '&.Mui-disabled': { backgroundColor: '#f5f5f5' },
// };

const labelStyle = {
  fontFamily: '"Poppins", sans-serif',
  color: Default_Text_Color,
  mb: 0.5,
  fontWeight: '600',
};

const boxStyle = {
  pt: 2,
  pb: 4,
  px: 3,
  boxShadow: "0px 4px 14px #1e66ab33",
  borderRadius: "14px",
  mb: 3,
};


const SectionHeader = ({ title }: { title: string }) => {
  const SpecificIcon = sectionIconMap[title]

  const isWip = title === "WIP";

  return (
    <Grid2 size={12}>
      <Typography
        variant="h6"
        sx={{
          fontFamily: '"Poppins SemiBold", "Poppins", sans-serif',
          fontWeight: 600,
          color: Default_Text_Color,
          display: "flex",
          alignItems: "center",
          gap: 1,
          mb: 1,
        }}
      >
        <Box sx={{ backgroundColor: isWip ? "#6eb7df" : Default_Text_Color, borderRadius: "50%", height: "32px", width: "32px", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <SpecificIcon sx={{ fontSize: '1.35rem', color: "#FFF" }} />
        </Box>

        {title}
      </Typography>
    </Grid2>
  );
};


const InstructionsSectionHeader = () => {
  const SpecificIcon = InfoOutlined;

  return (
    <Grid2 size={12}>
      <Typography
        variant="h6"
        sx={{
          fontFamily: '"Poppins SemiBold", "Poppins", sans-serif',
          fontWeight: 600,
          color: Default_Text_Color,
          display: "flex",
          alignItems: "center",
          gap: 1,
          mb: 1,
        }}
      >
        Instructions
        <SpecificIcon sx={{ fontSize: '1.35rem', color: Default_Text_Color }} />
      </Typography>
    </Grid2>
  );
};

const LabelTextField = ({
  label,
  placeholder,
  id,
}: {
  label: string;
  placeholder: string;
  id: string;
}) => (
  <Grid2 size={{ xs: 12, sm: 4 }}>
    <Typography sx={labelStyle}>{label}</Typography>
    <CustomTextField
      id={id}
      label={placeholder}
      hideLabel={true}
      variant="outlined"
      disable
      slotProps={{ input: { disableUnderline: true } }}
      sx={boxInputStyles}

    />
  </Grid2>
);


const TableSection = ({
  title,
  tables,
}: {
  title: string;
  tables: { data: any; columnsConfig: any, title: any }[];
}) => (
  <Grid2 size={12} container direction="column" spacing={2}>
    <SectionHeader title={title} />
    <Grid2 container spacing={2} size={12} sx={{ alignItems: 'stretch' }}>
      {tables.map((t, index) => (
        <Grid2
          key={index}
          size={{ xs: 12, md: 6 }}
          sx={{ display: 'flex', flexDirection: 'column' }}
        >

          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', '& > *': { flex: 1 } }}>
            <CustomCommercialDataTable data={t.data} columnsConfig={t.columnsConfig} title={t.title} />
          </Box>
        </Grid2>
      ))}
    </Grid2>
  </Grid2>
);


const ProposalFeeStageCommercialDates: React.FC<ProposalFeeStageCommercialDatesProps> = () => {
  const wipFields = [
    { label: 'WIP Balance', placeholder: 'Enter WIP Value', id: 'wip-balance' },
    { label: 'Average WIP Duration', placeholder: 'Enter average WIP Duration', id: 'average-wip-duration' },
    { label: 'Total Duration', placeholder: 'Enter total Duration', id: 'total-duration' },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", p: 1 }}>


      <Grid2 container spacing={2} size={12} sx={boxStyle}>
        <InstructionsSectionHeader />


        <Grid2 size={{ xs: 12, sm: 6 }} >
          <Typography sx={labelStyle}>Instructions Date</Typography>
          <CustomDatePicker
            id="date-field"
            placeholder="Select Date"
            sx={boxDatePickerStyles}
            disable
          />
        </Grid2>

        <Grid2 size={{ xs: 12, sm: 6 }}>
          <Typography sx={labelStyle}>Instructions Ref</Typography>
          <CustomTextField
            id="ref-field"
            label="Enter instructions Ref"
            hideLabel={true}
            variant="outlined"
            disable
            slotProps={{ input: { disableUnderline: true } }}
            sx={boxInputStyles}

          />
        </Grid2>


        <Grid2 size={{ xs: 12, sm: 6 }}>
          <Typography sx={labelStyle}>Instructions Type</Typography>
          <CustomDropdown
            id="type-field"
            label="Select instruction type"
            value="-1"
            onChange={() => { }}
            disable
            options={[]}
            sx={boxDropdownStyles}

          />
        </Grid2>
      </Grid2>

      {/* ── WIP Section ── */}
      <Grid2 container spacing={2} size={12} sx={boxStyle}>
        <SectionHeader title="WIP" />

        {wipFields.map((field) => (
          <LabelTextField key={field.id} {...field} />
        ))}


        <Grid2 container spacing={2} size={12} sx={{ mt: 2, alignItems: 'stretch' }}>
          <Grid2
            size={{ xs: 12, md: 6 }}
            sx={{ display: 'flex', flexDirection: 'column' }}
          >
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', '& > *': { flex: 1 } }}>
              <CustomCommercialDataTable data={sampleData2} columnsConfig={columnsConfig} title="Wip Accrued" />
            </Box>
          </Grid2>
          <Grid2
            size={{ xs: 12, md: 6 }}
            sx={{ display: 'flex', flexDirection: 'column' }}
          >
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', '& > *': { flex: 1 } }}>
              <CustomCommercialDataTable data={sampleDataTable2} columnsConfig={columnsConfig2} title="Wip Release" />
            </Box>
          </Grid2>
        </Grid2>
      </Grid2>

      {/* ── AFP Section ── */}
      <Grid2 container spacing={2} size={12} sx={boxStyle}>
        <SectionHeader title="AFP" />
        <Grid2 size={12}>
          <CustomCommercialDataTable data={sampleDataTableAFP} columnsConfig={columnsConfigAFP} />
        </Grid2>
      </Grid2>


      <Grid2 container spacing={4} size={12} sx={{ alignItems: 'stretch' }}>

        {/* Pre-billing */}
        <Grid2
          size={{ xs: 12, md: 6 }}
          sx={{ ...boxStyle, display: 'flex', flexDirection: 'column' }}
        >
          <TableSection
            title="Pre-billing"
            tables={[
              { data: sampleDataTableprebilling1, columnsConfig: columnsConfigprebilling1, title: "Pre-Billing Accured" },
              { data: sampleDataTableprebilling2, columnsConfig: columnsConfigprebilling2, title: "Pre-Billing Release" },
            ]}
          />
        </Grid2>

        {/* Invoicing */}
        <Grid2
          size={{ xs: 12, md: 6 }}
          container
          direction="column"
          spacing={2}
          sx={{ ...boxStyle, display: 'flex', flexDirection: 'column' }}
        >
          <SectionHeader title="Invoicing" />
          <Grid2 size={12} sx={{ flex: 1, display: 'flex', flexDirection: 'column', '& > *': { flex: 1 } }}>
            <CustomCommercialDataTable
              data={sampleDataTableInvoicing}
              columnsConfig={columnsConfigInvoicing}
            />
          </Grid2>
        </Grid2>

      </Grid2>

    </Box>
  );
};

export default ProposalFeeStageCommercialDates;
